/* istanbul ignore file */

const urlParser = require('url')

function pathMatch (url, path) {
  try {
    return path === urlParser.parse(url).pathname
  } catch (e) {
    return false
  }
}

function webpackHotMiddleware (compiler, opts) {
  opts = opts || {}
  opts.path = opts.path || '/__webpack_hmr'
  opts.heartbeat = opts.heartbeat || 10 * 1000

  let eventStream = createEventStream(opts.heartbeat)
  let latestStats = null
  let closed = false

  if (compiler.hooks) {
    compiler.hooks.invalid.tap('webpack-hot-middleware', onInvalid)
    compiler.hooks.done.tap('webpack-hot-middleware', onDone)
  } else {
    compiler.plugin('invalid', onInvalid)
    compiler.plugin('done', onDone)
  }

  function onInvalid () {
    if (closed) return

    latestStats = null
    eventStream.publish({ action: 'building' })
  }

  function onDone (statsResult) {
    if (closed) return

    latestStats = statsResult
    publishStats('built', latestStats, eventStream)
  }

  const middleware = function (req, res, next) {
    if (closed) return next()
    if (!pathMatch(req.url, opts.path)) return next()

    eventStream.handler(req, res)

    if (latestStats) {
      publishStats('sync', latestStats, eventStream)
    }
  }

  middleware.publish = function (payload) {
    if (closed) return
    eventStream.publish(payload)
  }

  middleware.close = function () {
    if (closed) return

    closed = true
    eventStream.close()
    eventStream = null
  }
  return middleware
}

function createEventStream (heartbeat) {
  let clientId = 0
  let clients = {}

  function everyClient (fn) {
    Object.keys(clients).forEach(function (id) {
      fn(clients[id])
    })
  }

  const interval = setInterval(function heartbeatTick () {
    everyClient(function (client) {
      client.write('data: \uD83D\uDC93\n\n')
    })
  }, heartbeat).unref()

  return {
    close: () => {
      clearInterval(interval)
      everyClient(function (client) {
        if (!client.finished) client.end()
      })
      clients = {}
    },
    handler: (req, res) => {
      const headers = {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'text/event-stream;charset=utf-8',
        'Cache-Control': 'no-cache, no-transform',
        'X-Accel-Buffering': 'no'
      }

      const isHttp1 = !(parseInt(req.httpVersion) >= 2)

      if (isHttp1) {
        req.socket.setKeepAlive(true)

        Object.assign(headers, {
          Connection: 'keep-alive'
        })
      }

      res.writeHead(200, headers)
      res.write('\n')

      const id = clientId++
      clients[id] = res

      req.on('close', function () {
        if (!res.finished) res.end()
        delete clients[id]
      })
    },
    publish: (payload) => {
      everyClient(client => {
        client.write('data: ' + JSON.stringify(payload) + '\n\n')
      })
    }
  }
}

function publishStats (action, statsResult, eventStream) {
  const stats = statsResult.toJson({
    all: false,
    cached: true,
    children: true,
    modules: true,
    timings: true,
    hash: true,
    errors: true,
    warnings: true
  })

  const bundles = extractBundles(stats)
  bundles.forEach(stats => {
    let name = stats.name || ''

    // Fallback to compilation name in case of 1 bundle (if it exists)
    if (bundles.length === 1 && !name && statsResult.compilation) {
      name = statsResult.compilation.name || ''
    }

    eventStream.publish({
      name: name || '',
      action: action || '',
      time: stats.time || '',
      hash: stats.hash || '',
      warnings: formatErrors(stats.warnings),
      errors: formatErrors(stats.errors),
      modules: buildModuleMap(stats.modules)
    })
  })
}

function formatErrors (errors) {
  if (!errors || !errors.length) return []

  if (typeof errors[0] === 'string') return errors

  return errors.map(function (error) {
    return error.moduleName + ' ' + error.loc + '\n' + error.message
  })
}

function extractBundles (stats) {
  if (stats.modules) return [stats]
  if (stats.children && stats.children.length) return stats.children

  return [stats]
}

function buildModuleMap (modules) {
  const map = {}

  modules.forEach(function (module) {
    map[module.id] = module.name
  })

  return map
}

module.exports = { webpackHotMiddleware }
